import { render, staticRenderFns } from "./ModalPositionAdvanced.vue?vue&type=template&id=b44ed2ee&scoped=true"
import script from "./ModalPositionAdvanced.vue?vue&type=script&lang=js"
export * from "./ModalPositionAdvanced.vue?vue&type=script&lang=js"
import style0 from "./ModalPositionAdvanced.vue?vue&type=style&index=0&id=b44ed2ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44ed2ee",
  null
  
)

export default component.exports